<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :allow-edit="false"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete ref="processComplete" :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      :config="config">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
// Author Pan Yu Rou
// Date 2024-08-09 16:06:00

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete.vue";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine.vue";
import emApiMixin from "@/mixin/em/common/api";


export default {
    name: "sithMesPrdZpp1WorkflowTaskView",
    components: {WorkflowProcessLine, WorkflowTaskComplete},
    mixins: [emWorkflowTaskMixin, workflowTaskMixins, emApiMixin],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        config() {
            return {
                'task1': {
                    name: '申请创建物料',
                    variables: [
                        {
                            label: '发起或结束流程',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '发起流程'},
                                {value: 2, text: '结束流程'}
                            ],
                        },
                        {
                            label: '备注',
                            name: 'comment',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.FLOW,
                            initData: true,
                        }
                    ],
                    userSelectMap: {
                        1: [
                            {
                                name: 'task2_candidates',
                                allowMulti: true,
                                require: true,
                                labelWithout: '指派物料属性审核人'
                            }
                        ],
                    },
                    approveToNextTask: {
                        1: 'task2',
                        2: 'EndEvent'
                    },
                },
                'task2': {
                    name: '判定物料属性-OM',
                    variables: [
                        {
                            label: '审核结果',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '通过'},
                                {value: 2, text: '退回'}
                            ],
                            require: true,
                        },
                        {
                            needTag: 'needApprove',
                            label: '物料属性是否正确',
                            name: 'materialPropertyVerified',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: [
                                {value: true, text: '是'},
                                {value: false, text: '否'},
                            ],
                            require: true,
                        },
                        {
                            label: '备注',
                            name: 'comment',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.FLOW,
                            initData: true,
                        }
                    ],
                    changeTag: (_, approve) => {
                        return this.buildTag('needApprove', approve === 1);
                    },
                    userSelectMap: {
                        '1': [
                            {
                                name: 'task3_candidates',
                                allowMulti: true,
                                require: true,
                                labelWithout: '指派价格属性审核人'
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task3',
                        2: 'task2'
                    },
                },
                'task3': {
                    name: '审核数据价格',
                    variables: [
                        {
                            label: '审核结果',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '通过'},
                                {value: 2, text: '退回'}
                            ],
                        },
                        {
                            needTag: 'needApprove',
                            label: '价格属性是否审核',
                            name: 'pricePropertyReviewed',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: [
                                {value: true, text: '是'},
                                {value: false, text: '否'},
                            ],
                            require: true,
                        },
                        {
                            needTag: 'needApprove',
                            label: '价格是否维护',
                            name: 'priceMaintained',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: [
                                {value: true, text: '是'},
                                {value: false, text: '否'},
                            ],
                            require: true,
                        },

                        {
                            label: '备注',
                            name: 'comment',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.FLOW,
                            initData: true,
                        }
                    ],
                    changeTag: (_, approve) => {
                        return this.buildTag('needApprove', approve === 1);
                    },
                    userSelectMap: {
                        '1': [
                            {
                                name: 'task4_candidates',
                                allowMulti: true,
                                require: true,
                                labelWithout: '指派物料上挂审核人'
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task4',
                        2: 'task2'
                    },
                },
                'task4': {
                    name: '物料号码上挂',
                    variables: [
                        {
                            label: '审核结果',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '通过'},
                                {value: 2, text: '退回'}
                            ],
                        },
                        {
                            needTag: 'needApprove',
                            label: '是否上挂',
                            name: 'mounted',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: [
                                {value: true, text: '是'},
                                {value: false, text: '否'},
                            ],
                            require: true,
                        },
                        {
                            label: '备注',
                            name: 'comment',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.FLOW,
                            initData: true,
                        }
                    ],
                    changeTag: (_, approve) => {
                        return this.buildTag('needApprove', approve === 1);
                    },
                    userSelectMap: {
                        '1': [
                            {
                                name: 'task5_candidates',
                                allowMulti: true,
                                require: true,
                                labelWithout: '指派工艺路线维护人'
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task5',
                        2: 'task3'
                    },
                },
                'task5': {
                    name: '维护工艺路线',
                    variables: [
                        {
                            label: '审核结果',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '通过'},
                                {value: 2, text: '退回'}
                            ],
                        },
                        {
                            needTag: 'needApprove',
                            label: '工艺路线是否维护',
                            name: 'routeMaintained',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: [
                                {value: true, text: '是'},
                                {value: false, text: '否'},
                            ],
                            require: true,
                        },
                        {
                            label: '备注',
                            name: 'comment',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.FLOW,
                            initData: true,
                        }
                    ],
                    changeTag: (_, approve) => {
                        return this.buildTag('needApprove', approve === 1);
                    },
                    userSelectMap: {
                        '1': [
                            {
                                name: 'task6_candidates',
                                allowMulti: true,
                                require: true,
                                labelWithout: '指派工单创建人'
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task6',
                        2: 'task4'
                    },
                },
                'task6': {
                    name: '工单创建释放',
                    variables: [
                        {
                            label: '审核结果',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '通过'},
                                {value: 2, text: '退回'}
                            ],
                        },
                        {
                            needTag: 'needApprove',
                            label: '工单号',
                            name: 'orderCode',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                        },
                        {
                            label: '备注',
                            name: 'comment',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.FLOW,
                            initData: true,
                        }
                    ],
                    changeTag: (_, approve) => {
                        return this.buildTag('needApprove', approve === 1);
                    },
                    userSelectMap: {
                        '1': [
                            {
                                name: 'task7_candidates',
                                allowMulti: true,
                                require: true,
                                labelWithout: '指派成本核查员'
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task7',
                        2: 'task5'
                    },
                },
                'task7': {
                    name: '工单核查成本',
                    variables: [
                        {
                            label: '审核结果',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '通过'},
                                {value: 2, text: '退回'}
                            ],
                        },
                        {
                            needTag: 'needApprove',
                            label: '成本是否进入',
                            name: 'costEntered',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: [
                                {value: true, text: '是'},
                                {value: false, text: '否'},
                            ],
                            require: true,
                        },
                        {
                            label: '备注',
                            name: 'comment',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.FLOW,
                            initData: true,
                        }
                    ],
                    changeTag: (_, approve) => {
                        return this.buildTag('needApprove', approve === 1);
                    },
                    approveToNextTask: {
                        1: 'EndEvent',
                        2: 'task6'
                    },
                },
                'EndEvent': {
                    name: '结束'
                }
            }
        }

    }
};
</script>